/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationChange } from './ConfigurationChange';
import {
    ConfigurationChangeFromJSON,
    ConfigurationChangeFromJSONTyped,
    ConfigurationChangeToJSON,
    ConfigurationChangeToJSONTyped,
} from './ConfigurationChange';

/**
 * 
 * @export
 * @interface ConfigurationHistoryPage
 */
export interface ConfigurationHistoryPage {
    /**
     * 
     */
    items: Array<ConfigurationChange>;
    /**
     * 
     */
    next_cursor: string;
}

/**
 * Check if a given object implements the ConfigurationHistoryPage interface.
 */
export function instanceOfConfigurationHistoryPage(value: object): value is ConfigurationHistoryPage {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('next_cursor' in value) || value['next_cursor'] === undefined) return false;
    return true;
}

export function ConfigurationHistoryPageFromJSON(json: any): ConfigurationHistoryPage {
    return ConfigurationHistoryPageFromJSONTyped(json, false);
}

export function ConfigurationHistoryPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationHistoryPage {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ConfigurationChangeFromJSON)),
        'next_cursor': json['next_cursor'],
    };
}

export function ConfigurationHistoryPageToJSON(json: any): ConfigurationHistoryPage {
    return ConfigurationHistoryPageToJSONTyped(json, false);
}

export function ConfigurationHistoryPageToJSONTyped(value?: ConfigurationHistoryPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ConfigurationChangeToJSON)),
        'next_cursor': value['next_cursor'],
    };
}

